export default __webpack_public_path__ + "static/media/wh_ep2_accuse_frey.7ecae147.jpg";